module.exports = __webpack_public_path__ + "assets/img/Type E (63).22df5cb8.jpg";